import React from 'react';
import {OverlaySpinner} from '@components/atoms';
import {Layout} from '@components/layouts/layout/Layout';

export const LoadingLayout: React.FC = () => {
  return (
    <Layout header={null}>
      <OverlaySpinner />
    </Layout>
  );
};
